"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var payment2C2PStyles = styles_1.makeStyles(function (_a) {
    var _b;
    var palette = _a.palette, typography = _a.typography, breakpoints = _a.breakpoints;
    return ({
        subtitle: {
            fontWeight: typography.fontWeightBold,
            fontSize: '20px',
            textAlign: 'center',
            paddingBottom: '10px',
        },
        description: {
            fontSize: '16px',
            textAlign: 'center',
            paddingBottom: '10px',
            whiteSpace: 'pre-wrap',
        },
        payButton: {
            fontWeight: 400,
            padding: '8px 40px',
            margin: '30px auto',
            display: 'block',
            maxWidth: 'unset',
            width: 'fit-content',
            '& span': {
                fontSize: '14px',
            },
            borderRadius: '4px',
            minWidth: '200px',
        },
        iframeContainer: (_b = {
                marginTop: '60px',
                minHeight: '700px',
                margin: '0 auto',
                width: '100%'
            },
            _b[breakpoints.up('lg')] = {
                width: '75%',
            },
            _b['& iframe'] = {
                width: '100%',
                minHeight: 'inherit',
            },
            _b),
        email: {
            display: 'inline',
            color: palette.primary.main,
            textDecoration: 'underline',
        },
        description2: {
            fontSize: typography.fontMD,
            textAlign: 'center',
            marginTop: '20px',
            display: 'block',
        },
        hiddenFrame: {
            display: 'none',
        },
        container: {},
    });
}, { name: 'Gql_Payment2C2P' });
exports.default = payment2C2PStyles;
